import { Injectable } from '@angular/core';
import { ApiEntityService } from '@core/api/api-entity.service';
import { Automapper } from '@core/api/mapper';
import { UserNamespacedResourceBaseUrlBuilder } from '@core/user-namespaced-resource-base-url-builder.service';

import { ApiService } from '@core/api/api.service';
import { PendingAreaContent } from '@core/models/pending-area-content.model';

import { BehaviorSubject, Observable } from 'rxjs';
import { PendingAreaContentState, PendingAreaContentStore } from './pending-area-content.store';
import { finalize, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PendingAreaContentService extends ApiEntityService<PendingAreaContentState> {
  private isLoading = new BehaviorSubject<boolean>(false);

  constructor(
    store: PendingAreaContentStore,
    urlBuilder: UserNamespacedResourceBaseUrlBuilder,
    private apiService: ApiService,
  ) {
    super(store, urlBuilder, Automapper.create(PendingAreaContent));
  }

  fetchPendingAreaContent(): Observable<PendingAreaContent[]> {
    return this.apiService.get<PendingAreaContent[]>(`common/holding-area-sites`).pipe(
      tap((data) => {
        this.store.remove();
        this.store.set(data);
      }),
      finalize(() => this.isLoading.next(false)),
    );
  }
}
